import React from "react"

/**
 * Повертає HTML
 * @param {*} descriptions один текстовий рядок або масив текстових рядків.
 * @returns 
 */
 export function BuildDescription({ descriptions }) {
  if (Array.isArray(descriptions)) {
    return <div>
      {
        descriptions.map((item, idx) => {
          return (
            <p key={idx} className='sertificat__text__paragraph'>
              {item}
            </p>
          )
        })
      }
    </div>
  }

  if (!descriptions.trim().length) {
    return null
  }
  

  return <p className='sertificat__text__paragraph'>
    {descriptions}
  </p>
}


// WEBPACK FOOTER //
// ./src/components/snippets/ChiefSliderComponent/shared/item/BuildDescription.jsx